import { CancelOutlined } from "@mui/icons-material";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

function APIAMemberSearchForm(props) {
  const NAME = "NAME";
  const MEMBER_NUMBER = "MEMBER_NUMBER";
  const DECAL_NUMBER = "DECAL_NUMBER";
  const PHONE_NUMBER = "PHONE_NUMBER";

  const formRef = useRef();
  const { t } = useTranslation();
  const [memberNumber, setMemberNumber] = useState(props.memberNumber || "");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [decalNumber, setDecalNumber] = useState(props.decalNumber || "");
  const [phoneNumber, setPhoneNumber] = useState(
    props.currState.MemberLookup.phoneNumber || props.phoneNumber.replace(/\D/g, "") || "",
  );

  const [searchTypes, setSearchTypes] = useState([
    { key: NAME, value: t("APIA.ContractSearch.DropdownOptions4") },
    { key: MEMBER_NUMBER, value: t("APIA.ContractSearch.DropdownOptions2") },
    { key: DECAL_NUMBER, value: t("APIA.ContractSearch.DropdownOptions1") },
    { key: PHONE_NUMBER, value: t("APIA.ContractSearch.DropdownOptions5") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(props.currState.MemberLookup?.searchType || NAME);

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    devLog("APIAMemberSearchForm useEffect", phoneNumber.replaceAll("/[^0-9]/g", ""));
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        decalNumber: decalNumber,
        searchType: selectedSearchType,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        decalNumber: decalNumber,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  const windowWidth = () => {
    if (width < 720) {
      return "group-1 group-v2 input-v2";
    } else {
      return "group-1";
    }
  };

  const windowWidth2 = () => {
    if (width < 720) {
      return "label label-v2";
    } else {
      return "label";
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => setSelectedSearchType(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/* Decal Number */}
          {selectedSearchType === DECAL_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("APIA.ContractSearch.DropdownOptions1")}:</div>
                <input
                  type="number"
                  placeholder="ex: 12345"
                  name="decalNumber"
                  className="input form-control required"
                  value={decalNumber}
                  onChange={(e) => {
                    setDecalNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* Member Number */}
          {selectedSearchType === MEMBER_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("APIA.ContractSearch.DropdownOptions2")}:</div>
                <input
                  type="text"
                  placeholder={t("APIA.ContractSearch.DropdownOptions2")}
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* First Name */}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("APIA.ContractSearch.DropdownSubOptions1")}:</div>
                <input
                  type="text"
                  placeholder="ex: JOHN"
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* Last Name */}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("APIA.ContractSearch.DropdownSubOptions2")}:</div>
                <input
                  type="text"
                  placeholder="ex: DOE"
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* Phone Number */}
          {selectedSearchType === PHONE_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  placeholder="ex: 1234567890"
                  name="phoneNumber"
                  className="input form-control required"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default APIAMemberSearchForm;
